import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { postStoreCustomerAccountTransaction } from "../../services/StoreCustomerAccount/postStoreCustomerAccountTransaction";

const AddBalanceToWalletAccountModal = ({
  addBalanceToWalletAccountModalVisible,
  setAddBalanceToWalletAccountModalVisible,
  storeCustomerId,
  storeId,
  storeUserId,
  sendPaymentDetailsPage,
}) => {
  const [amountValue, setAmountValue] = useState("");
  const [remarkValue, setRemarkValue] = useState("");
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  // Function to reset the state variables
  const resetFields = () => {
    setAmountValue("");
    setRemarkValue("");
  };

  // Initialize a state variable for storing pickup requests
  const [amountValueError, setAmountValueError] = useState("");
  const [remarkValueError, setRemarkValueError] = useState("");

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleAmountChange = (text) => {
    setAmountValue(text);
  };
  const handleRemarkChange = (text) => {
    setRemarkValue(text);
  };

  const onNextButtonPress = () => {
    if (amountValue === "") {
      setAmountValueError("Please Enter Amount Value");
    } else if (remarkValue === "") {
      setRemarkValueError("Please Enter Remark Value");
    } else {
      setAmountValueError("");
      setRemarkValueError("");
      if (!isPayNowButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsPayNowButtonPressed(true);
        const data = {
          transactionType: "Cr",
          payment: {
            receivedBy: storeUserId,
            paidBy: storeCustomerId,
            paymentRefNo: remarkValue,
            amount: amountValue,
            paymentMode: "cash",
          },
        };
        postStoreCustomerAccountTransaction(storeCustomerId, storeId, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res.status === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText("Balance Add Successfully");
                setAddBalanceToWalletAccountModalVisible(false);
                setIsPayNowButtonPressed(false);
                resetFields();

                sendPaymentDetailsPage({
                  status: Res.status,
                });
              } else {
                setModalVisible(true);
                setModalStatus("Failed");
                setModalText("Balance Failed");
                setAddBalanceToWalletAccountModalVisible(false);
                setIsPayNowButtonPressed(false);
                resetFields();
                sendPaymentDetailsPage({
                  status: Res.status,
                });
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    }
  };

  const handleModalClose = () => {
    setAddBalanceToWalletAccountModalVisible(false);
    setIsPayNowButtonPressed(false);
    resetFields();
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={addBalanceToWalletAccountModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!addBalanceToWalletAccountModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <i
                  className="pi pi-credit-card"
                  style={{
                    fontSize: "35px",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                ></i>
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Add Wallet Balance
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="mt-3 mx-6">
              <div>
                <p>Add Balance</p>
                <InputText
                  className="w-full text-xl h-3rem border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  value={amountValue}
                  onChange={(e) => handleAmountChange(e.target.value)}
                  onFocus={() => handleFocus("otherRemark")}
                  onBlur={handleBlur}
                />
              </div>

              <div className="my-2">
                <div>
                  <p>Reference No./ Remark</p>
                  <InputText
                    className="w-full text-xl h-3rem border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    value={remarkValue}
                    onChange={(e) => handleRemarkChange(e.target.value)}
                    onFocus={() => handleFocus("otherRemark")}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
            </div>

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={onNextButtonPress}
              disabled={isPayNowButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                ADD
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
       <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default AddBalanceToWalletAccountModal;
